export const PARSING_CASE_ORDER_BY_FIELDS = [
  { api: 'created_on', url: 'createdOn' },
  { api: 'modified_on', url: 'modifiedOn' },
  { api: 'status', url: 'status' },
  { api: 'primary_identifier', url: 'primaryIdentifier' },
] as const;

export const PARSING_CASE_ORDER_BY = PARSING_CASE_ORDER_BY_FIELDS.map(
  ({ api }) => api,
);

export const PARSING_CASE_ORDER_BY_URL = PARSING_CASE_ORDER_BY_FIELDS.map(
  ({ url }) => url,
);

export type ParsingCaseOrderByUrl =
  (typeof PARSING_CASE_ORDER_BY_FIELDS)[number]['url'];

type ParsingCaseOrderByApi =
  (typeof PARSING_CASE_ORDER_BY_FIELDS)[number]['api'];

export const PARSING_CASE_ORDER_BY_URL_TO_API = Object.fromEntries(
  PARSING_CASE_ORDER_BY_FIELDS.map(({ api, url }) => [url, api]),
) as Record<ParsingCaseOrderByUrl, ParsingCaseOrderByApi>;
